// Mutations
export const SET_ACTIVE_HISTORY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.activeHistory.data = payload
    state.activeHistory.lastUpdate = new Date()
  }
}
export const ADD_ACTIVE_HISTORY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.activeHistory.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.activeHistory.data.push(data)
      }
    })
  }
}
export const ADD_ACTIVE_HISTORY_REMOVED = (state, payload) => {
  const ids = Array.isArray(payload) ? payload : [payload]
  const next = state.activeHistory.removed.slice()
  ids.forEach((id) => {
    if (id !== null && id !== undefined && !next.includes(id)) next.push(id)
  })
  state.activeHistory.removed = next
}
export const SET_ACTIVE_HISTORY_LOADING = (state, payload) => {
  state.activeHistory.loading = payload
}

export const SET_ACCOUNTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.accounts.data = payload
    state.accounts.lastUpdate = new Date()
  }
}
export const ADD_ACCOUNTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.accounts.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.accounts.data.push(data)
      }
    })
  }
}
export const SET_ACCOUNTS_LOADING = (state, payload) => {
  state.accounts.loading = payload
}

export const SET_ACTIVE_CURRENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.activeCurrent.data = payload
    state.activeCurrent.lastUpdate = new Date()
  }
}
export const ADD_ACTIVE_CURRENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.activeCurrent.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.activeCurrent.data.push(data)
      }
    })
  }
}
export const SET_ACTIVE_CURRENT_LOADING = (state, payload) => {
  state.activeCurrent.loading = payload
}
export const SET_OPERATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.operations.data = payload
    state.operations.lastUpdate = new Date()
  }
}
export const ADD_OPERATIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.operations.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.operations.data.push(data)
      }
    })
  }
}
export const SET_OPERATIONS_LOADING = (state, payload) => {
  state.operations.loading = payload
}

export const SET_OPERATIONS_BASE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.operationsBase.data = payload
    state.operationsBase.lastUpdate = new Date()
  }
}
export const ADD_OPERATIONS_BASE = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.operationsBase.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.operationsBase.data.push(data)
      }
    })
  }
}
export const SET_OPERATIONS_BASE_LOADING = (state, payload) => {
  state.operationsBase.loading = payload
}

export const SET_CURRENT_STATUS = (state, payload) => {
  state.currentStatusStep = payload
}
export const SET_COMPARISON_INVESTMENT_ACCOUNTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.comparisonInvestmentAccounts.data = payload
    state.comparisonInvestmentAccounts.lastUpdate = new Date()
  }
}
export const ADD_COMPARISON_INVESTMENT_ACCOUNTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.comparisonInvestmentAccounts.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.comparisonInvestmentAccounts.data.push(data)
      }
    })
  }
}
export const SET_COMPARISON_INVESTMENT_ACCOUNTS_LOADING = (state, payload) => {
  state.comparisonInvestmentAccounts.loading = payload
}

export const SET_SUGGESTIONS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.suggestions.data = payload
    state.suggestions.lastUpdate = new Date()
  }
}
export const SET_SUGGESTIONS_LOADING = (state, payload) => {
  state.suggestions.loading = payload
}

export const SET_DATA_ROOM_LOADING = (state, payload) => {
  if (!state.dataRoomUi) state.dataRoomUi = { loading: false }
  state.dataRoomUi.loading = !!payload
}

export const SET_DATA_ROOM_FILTERS = (state, payload) => {
  const incoming = payload && typeof payload === 'object' ? payload : {}
  const current = state.dataRoomFilters || {}
  state.dataRoomFilters = Object.assign({}, current, incoming)
}
